  import React, {Component} from 'react';
import { drizzleConnect } from 'drizzle-react';
import PropTypes from 'prop-types';
  import {Link} from 'react-router';

class MarketPlace extends Component {
  constructor(props, context) {
    super(props);
    this.contract = context.drizzle.contracts.Alias;
    this.methods = this.contract.methods;
    this.web3Util = context.drizzle.web3.utils;
    this.postAliasForSale = this.postAliasForSale.bind(this);
    this.withdraw = this.withdraw.bind(this);
    this.isOwner = this.isOwner.bind(this);
    this.renderSingleListing = this.renderSingleListing.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleDirection = this.toggleDirection.bind(this);
    this.state = {
      forSale: [],
      owned: [],
      allContracts: [],
      search: '',
      filteredContracts: [],
      filterType: null,
      direction: 'ascending'
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (nextState.allContracts.length !== this.state.allContracts.length) ||
      nextState.forSale.length !== this.state.forSale.length ||
      this.state.search !== nextState.search ||
      this.state.direction !== nextState.direction;
  }

  componentDidMount() {
    this.updateContracts();
  }

  toggleDirection(sortType) {
    const newDirection = this.state.direction === 'ascending' ?
        'descending' :
        'ascending';
    let sorted;
    if (sortType === 'name') {
      if (newDirection === 'descending') {
        sorted = this.state.filteredContracts.sort((a, b) => a.alias.localeCompare(b.alias))
      } else {
        sorted = this.state.filteredContracts.sort((a, b) => b.alias.localeCompare(a.alias))
      }
    } else if (sortType === 'price') {
      if (newDirection === 'descending') {
        sorted = this.state.filteredContracts.sort((a, b) => a.price >= b.price)
      } else {
        sorted = this.state.filteredContracts.sort((a, b) => a.price <= b.price)
      }
    }
    this.setState({
      direction: newDirection,
      filteredContracts: sorted
    });
  }

  isOwner() {
      return this.methods.owner().call().then(owner => {
        return owner === this.props.accounts[0];
      });
  }

  withdraw() {
      return this.methods.withdraw.cacheSend(this.props.accounts[0]);
  }

  handleChange(event) {
    const filtered = this.state.allContracts.filter(({alias}) => alias.indexOf(event.target.value) >= 0);
    this.setState({
      [event.target.name]: event.target.value,
      filteredContracts: filtered
    });
  }

  updateContracts() {
    let isOwner;
    this.isOwner().then(result => {
        isOwner = result;
        return this.getAllContracts();
    }).then(contracts => {
      const accountAddresses = Object.keys(this.props.accounts).map(idx => this.props.accounts[idx]);
      const visibleContracts = contracts.filter(({address, isForSale}) => isForSale || accountAddresses.includes(address));
      const ownedAliases = contracts.filter(contract => accountAddresses.includes(contract.address));
      const aliasesForSale = contracts.filter(({price}) =>
        !isNaN(price));
      const filtered = visibleContracts.filter(({alias}) => alias.indexOf(this.state.search) >= 0);
      this.setState({
        accounts: accountAddresses,
        allContracts: visibleContracts,
        filteredContracts: filtered,
        owned: ownedAliases,
        forSale: aliasesForSale,
        isOwner: isOwner
      });
    });
  }

  handleSale(alias, price) {
    if (price) {
      return this.getAddressForAlias(alias).then(address => {
          const isValidAddress = this.state.accounts.includes(address);
          if (isValidAddress) {
            return this.postAliasForSale(alias, price);
          }
      });
    }
  }

  postAliasForSale(alias, price) {
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.putForSale.cacheSend(bytes, price);
  }

  getAllContracts() {
    return this.methods.getCount().call().then(count => {
        const aliasPromises = [];
        for (let i = 0; i < count; i++) {
            aliasPromises.push(this.methods.names(i).call());
        }
        let aliases = [];
        return Promise.all(aliasPromises).then(result => {
          aliases = result.map(item => this.web3Util.toAscii(item));
          const pricePromises = Promise.all(aliases.map(alias => this.getPrice(alias)));
          const addressPromises = Promise.all(aliases.map(alias => this.getAddressForAlias(alias)));
          return Promise.all([pricePromises, addressPromises]);
        }).then(([prices, addresses]) =>
          aliases.map((alias, idx) => ({
            alias,
            price: prices[idx],
            isForSale: !isNaN(prices[idx]) && prices[idx] !== '0',
            address: addresses[idx]
          }))
        );
    });
  }

  getAddressForAlias(alias) {
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.get(bytes).call();
  }

  getPrice(alias) {
    const convertCurrencyFromWei = (num) => this.web3Util.fromWei(num);
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.getPrice(bytes).call().then(price => {
      return price === '0' ? 'Not for sale' : Number(convertCurrencyFromWei(price))
    });
  }

  buyAlias(alias) {
    return this.getPrice(alias).then(price => {
      const weiCurrency = this.web3Util.toWei(price.toString());
      const bytes = this.web3Util.fromAscii(alias);
      this.methods.buy.cacheSend(bytes, {value: weiCurrency});
      this.setState({
        isPerformingAction: false,
        message: 'Your shiny new Ether DNS will be ready shortly after transaction is confirmed'
      });
    });
  }

  renderWithdraw() {
      if (this.state.isOwner) {
        return (
          <div className="title">
            <button className="pulse blue" onClick={evt => {
              this.withdraw();
              this.updateContracts();
            }}>Withdraw
            </button>
        </div>
        );
      }
  }

  renderSingleListing({alias, isForSale, price, address}) {
    const saleAction = (e) => {
      const $saleContainer = e.target.previousElementSibling;
      const price = $saleContainer.querySelector('input').value;
      if (!isNaN(price) && !!price) {
        const weiCurrency = this.web3Util.toWei(price);
        this.handleSale(alias, weiCurrency);
      }
    };
    const isOwner = this.state.accounts.includes(address);
    const buyAction = (e) => this.buyAlias(alias);
    const action = isForSale ? buyAction : saleAction;
    const priceComponent = isForSale ?
      <div className="buy-price">{price}</div> :
      <div className="sale-container">
        <input className="sell-value" placeholder='Sale Price' />
      </div>;

    const buttonLabel = isForSale ? 'Buy' : 'Sell';
    return (
      <div key={alias} className="listing">
        <Link className={"alias-name"} to={"/e/" + alias}>etherdns:{alias}</Link>
        {priceComponent}
        { !(isOwner && isForSale) ?
        <button className="pulse blue" onClick={evt => {
          action(evt);
          this.updateContracts();
        }}>{buttonLabel}</button> : <span>Listed for Sale</span> }
      </div>
    );
  }

  render() {
    const listings = this.state.filteredContracts.map(this.renderSingleListing);
    const withdraw = this.renderWithdraw();
    return (
      <div className="marketplace">
        {withdraw}
        <div className="title">Marketplace</div>
        <div className="body">Deep dive in the world of Ether DNS Exchange</div>
        <div className="search">
          <span>SEARCH</span>
          <input
            placeholder="Name"
            name='search'
            onChange={this.handleChange}
            value={this.state.search}
          />
        </div>
        <div>
          <div className="sorts">
            <span className="desc">SORT BY</span>
            <a className="sort-type" onClick={() => this.toggleDirection('price')}>[ Price ]</a>
            <a className="sort-type" onClick={() => this.toggleDirection('name')}>[ Name ]</a>
          </div>
        </div>
        <div className="list-container">
          {listings}
        </div>
      </div>
    );
  }
};

MarketPlace.contextTypes = {
  drizzle: PropTypes.object,
  contracts: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    contracts: state.contracts,
    accounts: state.accounts
  }
};

export default drizzleConnect(MarketPlace, mapStateToProps);



// WEBPACK FOOTER //
// ./src/components/MarketPlace.js